import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getReferralLinks = createAsyncThunk('referral/getReferralLinks', async (_, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${process.env.REACT_APP_SERVER_API}/referrals/links/`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
}); 